<template>
  <div>
    <SidebarVue ref="sidebar" />
    <NavgatorDk
      ref="navgator"
      :barraTitulo="'Administração BI'"
      :titulo="'bi'"
    />

    <div class="card-container">
      <!-- =========================
    FILTROS
    ========================= -->
      <div class="card filter-container">
        <div class="row g-2 p-2">
          <div
            class="card-title gy-4 d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <i class="bi bi-funnel fs-5 icon-text-form"></i>
              <span class="txt-title-form ms-2">Filtro</span>
            </div>

            <!-- botão collapse em mobile -->
            <button
              class="btn btn-filtro d-inline-flex align-items-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#biFilters"
              aria-expanded="true"
              aria-controls="biFilters"
              style="max-width: 40px"
            >
              <i class="bi bi-chevron-down"></i>
            </button>
          </div>
        </div>

        <div id="biFilters" class="collapse show">
          <div class="row g-2 p-2">
            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="filters.rede"
                >
                  <option
                    v-for="r in filterOptions.redes"
                    :key="r.value"
                    :value="r.value"
                  >
                    {{ r.label }}
                  </option>
                </select>
                <label>Rede</label>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="filters.loja"
                >
                  <option value="">Todas as Lojas</option>
                  <option
                    v-for="l in filterOptions.lojasFiltradas"
                    :key="l.id"
                    :value="l.id"
                  >
                    {{ l.nome }}
                  </option>
                </select>
                <label>Loja</label>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-control txt-form-input"
                  v-model="filters.periodo"
                >
                  <option value="7">Últimos 7 dias</option>
                  <option value="15">Últimos 15 dias</option>
                  <option value="30">Últimos 30 dias</option>
                  <option value="60">Últimos 60 dias</option>
                  <option value="90">Últimos 90 dias</option>
                  <option value="120">Últimos 120 dias</option>
                  <option value="custom">Personalizado</option>
                </select>
                <label>Período</label>
                <div v-if="filters.periodo === 'custom'" class="row mt-2">
                  <div class="col-md-6">
                    <label>Data Inicial</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.startDate"
                    />
                  </div>

                  <div class="col-md-6">
                    <label>Data Final</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.endDate"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="filters.gerente"
                >
                  <option value="">Todos os Gerentes</option>
                  <option
                    v-for="g in filterOptions.gerentesFiltrados"
                    :key="g.id"
                    :value="g.id"
                  >
                    {{ g.nome }}
                  </option>
                </select>
                <label>Gerente</label>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-control txt-form-input"
                  v-model="filters.pcd"
                >
                  <option value="all">Todos</option>
                  <option value="1">Somente Venda Direta</option>
                  <option value="0">Sem Venda Direta</option>
                </select>
                <label>Venda Direta</label>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-control txt-form-input"
                  v-model="filters.statusVenda"
                >
                  <option value="all">Todos</option>
                  <option value="finalizado">Finalizado</option>
                  <!-- <option value="pendente">Pendente</option> -->
                  <option value="perdido">Perdido</option>
                </select>
                <label>Status de Venda</label>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-2 d-flex gap-2 p-2">
            <button class="btn btn-primario" @click="applyFilters">
              <i class="bi bi-search me-2"></i>
              Aplicar
            </button>

            <button class="btn btn-secundario" @click="resetFilters">
              <i class="bi bi-arrow-counterclockwise me-2"></i>
              Limpar
            </button>
          </div>
        </div>
      </div>
      <!-- =========================
    KPIs
    ========================= -->
      <div class="dashboard-admin">
        <div class="row g-2 p-2">
          <!--TOTAL ATENDIMENTOS-->
          <div class="col-12 col-sm-6 col-lg">
            <div class="card-menu-bi">
              <div class="card-header-bi">
                <span class="card-title-bi">Total Atendimentos</span>
                <i class="bi bi-people-fill"></i>
              </div>
              <div class="card-value-bi">{{ kpis.totalAtendimentos }}</div>
              <div class="card-period-bi">No período selecionado</div>
            </div>
          </div>
          <!--VENDAS FINALIZADAS-->
          <div class="col-12 col-sm-6 col-lg">
            <div class="card-menu-bi status-finalizado-bi">
              <div class="card-header-bi">
                <span class="card-title-bi">Vendas Finalizadas</span>
                <i class="bi bi-check-circle-fill"></i>
              </div>
              <div class="card-value-bi">{{ kpis.vendasFinalizadas }}</div>
              <div class="card-period-bi">{{ kpis.conversao }}% conversão</div>
            </div>
          </div>
          <!--VENDAS PERDIDAS-->
          <div class="col-12 col-sm-6 col-lg">
            <div class="card-menu-bi status-perdido-bi">
              <div class="card-header-bi">
                <span class="card-title-bi">Vendas Perdidas</span>
                <i class="bi bi-x-circle-fill"></i>
              </div>
              <div class="card-value-bi">{{ kpis.vendasPerdidas }}</div>
              <div class="card-period-bi">Oportunidades de melhoria</div>
            </div>
          </div>
          <!--TAXA DE CONVERSÃO-->
          <div class="col-12 col-sm-6 col-lg">
            <div class="card-menu-bi status-pendente-bi">
              <div class="card-header-bi">
                <span class="card-title-bi">Venda Direta</span>
                <i class="bi bi-universal-access-circle"></i>
              </div>
              <div class="card-value-bi">{{ kpis.clientesPcd }}</div>
              <div class="card-period-bi">Impacto no funil</div>
            </div>
          </div>
        </div>
        <div class="row g-2 p-2">
          <!--MÉDIA VALOR VEÍCULO-->
          <div class="col-12 col-sm-6 col-lg">
            <div class="card-menu-bi">
              <div class="card-header-bi">
                <span class="card-title-bi">Média Valor Veículo</span>
                <i class="bi bi-currency-dollar"></i>
              </div>
              <div class="card-value-bi">
                {{ this.fmtBRL(kpis.mediaValorVeiculo) }}
              </div>
              <div class="card-period-bi">
                {{ kpis.qtdMediaVeiculos }} veículos
              </div>
            </div>
          </div>
          <!--VENDA TOTAL-->
          <div class="col-12 col-sm-6 col-lg">
            <div class="card-menu-bi status-finalizado-bi">
              <div class="card-header-bi">
                <span class="card-title-bi">Venda Total</span>
                <i class="bi bi-wallet"></i>
              </div>
              <div class="card-value-bi">
                {{ this.fmtBRL(kpis.vendaTotal) }}
              </div>
              <div class="card-period-bi">
                {{ kpis.totalVendasFinalizadas }} vendas finalizadas
              </div>
            </div>
          </div>
          <!--TEMPO MEDIO DE ATENDIMENTO-->
          <div class="col-12 col-sm-6 col-lg">
            <div class="card-menu-bi">
              <div class="card-header-bi">
                <span class="card-title-bi">Tempo Médio Atendimento</span>
                <i class="bi bi-clock"></i>
              </div>
              <div class="card-value-bi">
                {{ this.fmtDurationFromSec(kpis.tempoMedioAt) }}
              </div>
              <div class="card-period-bi">
                {{ kpis.totalRegistros }} registros
              </div>
            </div>
          </div>
          <!--MÉDIA DE MENUS-->
          <div class="col-12 col-sm-6 col-lg">
            <div class="card-menu-bi">
              <div class="card-header-bi">
                <span class="card-title-bi">Média de Menus</span>
                <i class="bi bi-file-earmark-text"></i>
              </div>
              <div class="card-value-bi">{{ kpis.mediaMenus }}</div>
              <div class="card-period-bi">
                {{ kpis.totalRegistros }} registros
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- =========================
     BLOCO 2 — CAPTURA DE CONTATOS
     ========================= -->
      <div class="row g-2 p-2">
        <div class="col-12">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <i class="bi bi-person-lines-fill icon-text-form"></i>
                <span class="txt-title-form ms-2">Captura de Contatos</span>
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#capContatos"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="capContatos" class="collapse show mt-2">
              <div class="bi-contact-grid mt-3">
                <!-- Total -->
                <div class="bi-contact-item">
                  <div class="bi-contact-head">
                    <i class="bi bi-people"></i>
                    <span>Total</span>
                  </div>

                  <div class="bi-contact-value">{{ contatos.total }}</div>
                  <div class="bi-contact-sub">atendimentos</div>
                </div>

                <!-- Tel 1 -->
                <div class="bi-contact-item">
                  <div class="bi-contact-head">
                    <i class="bi bi-telephone"></i>
                    <span>Tel 1</span>
                  </div>

                  <div class="bi-contact-value text-primary">
                    {{ contatos.tel1 }}
                  </div>
                  <div class="bi-contact-sub">
                    {{ pct(contatos.tel1, contatos.total) }}% captados
                  </div>
                </div>

                <!-- Tel 2 -->
                <div class="bi-contact-item">
                  <div class="bi-contact-head">
                    <i class="bi bi-phone"></i>
                    <span>Tel 2</span>
                  </div>

                  <div class="bi-contact-value">{{ contatos.tel2 }}</div>
                  <div class="bi-contact-sub">
                    {{ pct(contatos.tel2, contatos.total) }}% captados
                  </div>
                </div>

                <!-- Email -->
                <div class="bi-contact-item">
                  <div class="bi-contact-head">
                    <i class="bi bi-envelope"></i>
                    <span>E-mail</span>
                  </div>

                  <div class="bi-contact-value">{{ contatos.email }}</div>
                  <div class="bi-contact-sub">
                    {{ pct(contatos.email, contatos.total) }}% captados
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- =========================
     BLOCO 3 — ATENDIMENTOS / VENDAS POR DIA DA SEMANA
     ========================= -->
      <div class="row g-2 p-2">
        <div class="col-12 col-lg-6">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <span class="txt-title-form"
                  >Atendimentos por Dia da Semana</span
                >
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#c1"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="c1" class="collapse show mt-2">
              <div class="bi-chart-wrap">
                <canvas ref="chartAtendDiaSemana"></canvas>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <span class="txt-title-form">Vendas por Dia da Semana</span>
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#c2"
                aria-expanded="true"
                aria-controls="c2"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="c2" class="collapse show mt-2">
              <div class="bi-chart-wrap">
                <canvas ref="chartVendasDiaSemana"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- =========================
     BLOCO 4 — RANKINGS (VEÍCULOS / MODELOS)
     ========================= -->
      <div class="row g-2 p-2">
        <!-- Ranking de Veículos -->
        <div class="col-12 col-lg-6">
          <div class="card">
            <div
              class="d-flex align-items-start justify-content-between linha pb-2"
            >
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center">
                  <i class="bi bi-car-front-fill icon-text-form"></i>
                  <span class="txt-title-form ms-2">Ranking de Veículos</span>
                </div>
                <small class="text-muted ms-5"
                  >Top 10 veículos mais procurados</small
                >
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#rankVeiculos"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="rankVeiculos" class="collapse show mt-2">
              <div class="bi-rank-list">
                <div
                  v-for="item in rankingVeiculos"
                  :key="item.pos"
                  class="bi-rank-row"
                >
                  <div class="bi-rank-left">
                    <div class="bi-rank-pos">{{ item.pos }}°</div>
                  </div>

                  <div class="bi-rank-mid">
                    <div class="bi-rank-title" :title="item.nome">
                      {{ item.nome }}
                    </div>

                    <div class="bi-rank-meta">
                      <span class="bi-rank-meta-item">
                        {{ fmtInt(item.atend) }} atend.
                      </span>

                      <span class="bi-rank-meta-item bi-rank-link">
                        {{ fmtPct(item.share) }}
                      </span>

                      <span
                        class="bi-rank-meta-item"
                        :class="item.conv >= 0 ? 'bi-up' : 'bi-down'"
                      >
                        <i
                          class="bi"
                          :class="
                            item.conv >= 0 ? 'bi-graph-up' : 'bi-graph-down'
                          "
                        ></i>
                        {{ fmtPct(Math.abs(item.conv)) }} conv.
                      </span>
                    </div>

                    <div class="bi-rank-bar">
                      <div
                        class="bi-rank-bar-fill"
                        :style="{
                          width: barWidth(item.atend, maxAtendVeiculos)
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Volume de Vendas por Modelo -->
        <div class="col-12 col-lg-6">
          <div class="card">
            <div
              class="d-flex align-items-start justify-content-between linha pb-2"
            >
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center">
                  <i class="bi bi-currency-dollar icon-text-form"></i>
                  <span class="txt-title-form ms-2"
                    >Volume de Vendas por Modelo</span
                  >
                </div>
                <small class="text-muted ms-5"
                  >Top 10 modelos com maior faturamento</small
                >
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#volumeModelos"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="volumeModelos" class="collapse show mt-2">
              <div class="bi-rank-list">
                <div
                  v-for="item in rankingModelos"
                  :key="item.pos"
                  class="bi-rank-row"
                >
                  <div class="bi-rank-left">
                    <div class="bi-rank-pos">{{ item.pos }}°</div>
                  </div>

                  <div class="bi-rank-mid">
                    <div class="bi-rank-title" :title="item.nome">
                      {{ item.nome }}
                    </div>

                    <div class="bi-rank-meta">
                      <span class="bi-rank-meta-item">
                        {{ fmtInt(item.vendas) }}/{{ fmtInt(item.atend) }}
                      </span>

                      <span class="bi-rank-meta-item">
                        <i class="bi bi-graph-up"></i>
                        {{ fmtPct(item.conv) }}
                      </span>

                      <span class="bi-rank-meta-item bi-money">
                        {{ fmtBRL(item.faturamento) }}
                      </span>
                    </div>

                    <div class="bi-rank-bar">
                      <div
                        class="bi-rank-bar-fill"
                        :style="{
                          width: barWidth(item.faturamento, maxFatModelos)
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- =========================
     BLOCO 5 — LOJA + ORIGEM DE LEADS
     ========================= -->
      <div class="row g-2 p-2">
        <!-- Combo por Loja -->
        <div class="col-12 col-lg-7">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <i class="bi bi-shop icon-text-form"></i>
                <span class="txt-title-form ms-2"
                  >Atendimentos e Vendas por Loja</span
                >
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#vendasLojas"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="vendasLojas" class="collapse show mt-2">
              <div class="bi-chart-area">
                <canvas ref="chartLojaCombo"></canvas>
              </div>
              <div class="bi-legend-hint">
                <span><span class="dot dot-blue"></span>Atendimentos</span>
                <span><span class="dot dot-green"></span>Vendas</span>
                <span><span class="dot dot-dark"></span>Conversão (%)</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Origem de Leads -->
        <div class="col-12 col-lg-5">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <i class="bi bi-diagram-3-fill icon-text-form"></i>
                <span class="txt-title-form ms-2">Origem dos Leads</span>
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#leads"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="leads" class="collapse show mt-2">
              <div class="d-flex flex-row m-4 bi-chart-fixed">
                <!-- Gráfico (55%) -->
                <div style="width: 55%; height: 100%">
                  <canvas
                    ref="chartOrigemLeads"
                    style="width: 100%; height: 100%"
                  ></canvas>
                </div>

                <!-- Legenda com scroll (45%) -->
                <div
                  style="
                    width: 45%;
                    height: 100%;
                    overflow-y: auto;
                    padding-left: 12px;
                  "
                >
                  <table class="table table-sm table-borderless mb-0">
                    <tbody>
                      <tr
                        v-for="o in origemLeads"
                        :key="o.nome"
                        style="border-bottom: 1px solid #edf2f7"
                      >
                        <td
                          class="ps-0 py-1 text-truncate"
                          style="max-width: 100px"
                        >
                          {{ o.nome }}
                        </td>
                        <td class="text-end py-1 fw-bold">
                          {{ fmtInt(o.qtd) }}
                        </td>
                        <td
                          class="text-end py-1 text-secondary"
                          style="min-width: 45px"
                        >
                          {{ fmtPct(o.share) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- =========================
     BLOCO 6 — ATENDIMENTOS / VENDAS POR GERENTE
     ========================= -->
      <div class="row g-2 p-2">
        <div class="col-12 col-lg-7">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <i class="bi bi-person-badge-fill icon-text-form"></i>
                <span class="txt-title-form ms-2">
                  Atendimentos e Vendas por Gerente (ordenado por conversão)
                </span>
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#vendasGerentes"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="vendasGerentes" class="collapse show mt-2">
              <div class="bi-chart-area">
                <canvas ref="chartGerenteCombo"></canvas>
              </div>

              <div class="bi-legend-hint">
                <span><span class="dot dot-blue"></span>Atendimentos</span>
                <span><span class="dot dot-green"></span>Vendas</span>
                <span><span class="dot dot-dark"></span>Conversão (%)</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-5">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <i class="bi bi-pie-chart-fill icon-text-form"></i>
                <span class="txt-title-form ms-2">Status de Fechamento</span>
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#statusFechamento"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="statusFechamento" class="collapse show mt-2">
              <div class="d-flex flex-row m-4" style="height: 345px">
                <div style="width: 55%; height: 100%">
                  <canvas
                    ref="chartStatusFechamento"
                    style="width: 100%; height: 100%"
                  ></canvas>
                </div>
                <!-- Legenda com scroll (45%) -->
                <div
                  style="
                    width: 45%;
                    height: 100%;
                    overflow-y: auto;
                    padding-left: 12px;
                  "
                >
                  <table class="table table-sm table-borderless mb-0">
                    <tbody>
                      <tr
                        v-for="s in statusFechamento"
                        :key="s.nome"
                        style="border-bottom: 1px solid #edf2f7"
                      >
                        <td
                          class="ps-0 py-1 text-truncate"
                          style="max-width: 100px"
                        >
                          {{ s.nome }}
                        </td>
                        <td class="text-end py-1 fw-bold">
                          {{ fmtInt(s.qtd) }}
                        </td>
                        <td
                          class="text-end py-1 text-secondary"
                          style="min-width: 45px"
                        >
                          {{ fmtPct(s.pct) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- =========================
    BLOCO 8 — TEMPO DE ATENDIMENTO (TOP 3)
    ========================= -->
      <div class="row g-2 p-2">
        <!-- Mais longos -->
        <div class="col-12 col-lg-6">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <i class="bi bi-stopwatch-fill icon-text-form"></i>
                <span class="txt-title-form ms-2"
                  >Top 3 Atendimentos Mais Longos</span
                >
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#maiorAtendimento"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="maiorAtendimento" class="collapse show mt-2">
              <div class="bi-time-hint bi-time-hint-danger">
                <i class="bi bi-graph-up-arrow me-2"></i>
                Maior tempo de atendimento
              </div>

              <div class="bi-time-list mt-3">
                <div
                  v-for="(item, idx) in topAtendLongos"
                  :key="item.id"
                  class="bi-time-row"
                >
                  <div class="bi-time-rank bi-rank-danger">{{ idx + 1 }}</div>

                  <div class="bi-time-main">
                    <div class="bi-time-title">
                      <span class="bi-time-proto">Atend - {{ item.id }}</span>
                      <span class="bi-time-name">{{ item.cliente }}</span>
                    </div>

                    <div class="bi-time-sub">
                      {{ item.vendedor }} • {{ item.loja }}
                    </div>
                  </div>

                  <div class="bi-time-right">
                    <i class="bi bi-clock me-2"></i>
                    <span class="bi-time-duration">{{ item.tempo }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mais rápidos -->
        <div class="col-12 col-lg-6">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="d-flex align-items-center">
                <i class="bi bi-stopwatch icon-text-form"></i>
                <span class="txt-title-form ms-2"
                  >Top 3 Atendimentos Mais Rápidos</span
                >
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#menorAtendimento"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="menorAtendimento" class="collapse show mt-2">
              <div class="bi-time-hint bi-time-hint-success">
                <i class="bi bi-graph-down-arrow me-2"></i>
                Menor tempo de atendimento
              </div>

              <div class="bi-time-list mt-3">
                <div
                  v-for="(item, idx) in topAtendRapidos"
                  :key="item.id"
                  class="bi-time-row"
                >
                  <div class="bi-time-rank bi-rank-success">{{ idx + 1 }}</div>

                  <div class="bi-time-main">
                    <div class="bi-time-title">
                      <span class="bi-time-proto">Atend - {{ item.id }}</span>
                      <span class="bi-time-name">{{ item.cliente }}</span>
                    </div>

                    <div class="bi-time-sub">
                      {{ item.vendedor }} • {{ item.loja }}
                    </div>
                  </div>

                  <div class="bi-time-right">
                    <i class="bi bi-clock me-2"></i>
                    <span class="bi-time-duration">{{ item.tempo }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- =========================
     BLOCO 9 — COMPARATIVO LOJAS
     ========================= -->
      <div class="row g-2 p-2">
        <div class="col-12">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="bi-d-flex align-items-center-header">
                <i class="bi bi-bar-chart-line icon-text-form"></i>
                <span class="txt-title-form ms-2">
                  Comparativo entre Lojas</span
                >
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#comparativoLojas"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="comparativoLojas" class="collapse show mt-2">
              <div class="collapse show mt-2">
                <div class="mt-3">
                  <div class="row g-2">
                    <div
                      class="col-12 col-lg-2"
                      v-for="(s, idx) in compare.stores"
                      :key="idx"
                    >
                      <label class="txt-form-label mb-1"
                        >Loja {{ idx + 1 }}</label
                      >
                      <select
                        class="form-control txt-form-input"
                        v-model="compare.stores[idx]"
                      >
                        <option
                          v-for="opt in compare.storeOptions"
                          :key="opt.id"
                          :value="String(opt.id)"
                        >
                          {{ opt.nome }}
                        </option>
                      </select>
                    </div>
                    <div class="col-12 col-lg-1 d-flex align-items-end gap-2">
                      <button
                        class="btn btn-secundario btn-loja"
                        @click="addCompareStore"
                        :disabled="compare.stores.length >= compare.maxStores"
                      >
                        <i class="bi bi-plus-lg me-2"></i>
                      </button>

                      <button
                        class="btn btn-secundario"
                        :disabled="compare.stores.length <= 2"
                        @click="removeCompareStore"
                      >
                        <i class="bi bi-dash-lg me-2"></i>
                      </button>
                    </div>
                  </div>

                  <div class="table-responsive mt-3">
                    <table class="table align-middle">
                      <thead class="bi-table-head">
                        <tr>
                          <th class="txt-title-table-desk">Métrica</th>
                          <th
                            v-for="(col, idx) in compare.stores"
                            :key="idx"
                            class="txt-title-table-desk text-end"
                          >
                            {{ shortLabel(col.nome) }}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="row in compare.metrics" :key="row.key">
                          <td class="card-table-item">{{ row.label }}</td>

                          <td
                            v-for="(col, idx) in compare.stores"
                            :key="idx"
                            class="card-table-item text-end"
                          >
                            {{
                              formatMetric(
                                row.key,
                                getStoreMetric(col, row.key) ?? 0
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <small class="text-muted"
                    >Variação calculada: última loja vs primeira loja.</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- BLOCO 10 -->
      <div class="row g-2 p-2">
        <div class="col-12">
          <div class="card">
            <div
              class="d-flex align-items-center justify-content-between linha pb-2"
            >
              <div class="bi-d-flex align-items-center-header">
                <i class="bi bi-bar-chart-line icon-text-form"></i>
                <span class="txt-title-form ms-2">
                  Comparativo entre Períodos</span
                >
              </div>
              <button
                class="btn btn-filtro d-inline-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#comparativoPeriodos"
                aria-expanded="true"
                aria-controls="c1"
                style="max-width: 40px"
              >
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
            <div id="comparativoPeriodos" class="collapse show mt-2">
              <div class="row align-items-end g-3 mb-3">
                <!-- TIPO -->
                <div class="col-lg-2">
                  <div class="form-group">
                    <label class="txt-form-label">Tipo</label>

                    <select
                      class="form-control txt-form-input"
                      v-model="compare.periodMode"
                    >
                      <option value="date">Data</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>
                </div>

                <!-- LOJA -->

                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="txt-form-label">Loja</label>

                    <select
                      class="form-control txt-form-input"
                      v-model="compare.store"
                      @change="compare.mode = 'PERIODS'"
                    >
                      <option
                        v-for="l in compare.storeOptions"
                        :key="l.id"
                        :value="l.id"
                      >
                        {{ l.nome }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- ===================== -->
              <!-- DATA X DATA -->
              <!-- ===================== -->

              <div v-if="compare.periodMode === 'date'" class="row g-2 mt-3">
                <div class="col-lg-3">
                  <label class="txt-form-label">Data 1</label>

                  <flat-pickr
                    class="form-control txt-form-input calendar-input"
                    v-model="compare.dayDates.d1"
                    :config="dateConfig"
                  />
                </div>

                <div class="col-lg-3">
                  <label class="txt-form-label">Data 2</label>

                  <flat-pickr
                    class="form-control txt-form-input calendar-input"
                    v-model="compare.dayDates.d2"
                    :config="dateConfig"
                  />
                </div>
              </div>

              <!-- ===================== -->
              <!-- RANGE X RANGE -->
              <!-- ===================== -->

              <div v-if="compare.periodMode === 'custom'" class="row g-2 mt-3">
                <div class="row g-3 mt-2">
                  <div class="col-lg-4">
                    <label class="txt-form-label">Período 1</label>

                    <flat-pickr
                      class="form-control txt-form-input calendar-input"
                      v-model="compare.ranges.r1"
                      :config="rangeConfig"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label class="txt-form-label">Período 2</label>

                    <flat-pickr
                      class="form-control txt-form-input calendar-input"
                      v-model="compare.ranges.r2"
                      :config="rangeConfig"
                    />
                  </div>
                </div>
              </div>

              <!-- TABELA -->

              <div class="table-responsive mt-3">
                <table class="table align-middle">
                  <thead class="bi-table-head">
                    <tr>
                      <th>Métrica</th>

                      <th class="text-end">Período 1</th>

                      <th class="text-end">Período 2</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="row in compare.metrics" :key="row.key">
                      <td>{{ row.label }}</td>

                      <td class="text-end">
                        {{
                          formatMetric(row.key, compare.periodData.p1[row.key])
                        }}
                      </td>

                      <td class="text-end">
                        {{
                          formatMetric(row.key, compare.periodData.p2[row.key])
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Rodape />
  </div>
</template>

<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import NavgatorDk from "../../components/menu/NavgatorDk.vue";
import Rodape from "../../components/menu/Rodape.vue";
import { Chart, registerables } from "chart.js";
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
Chart.register(...registerables);

export default {
  name: "RelatorioBI",
  components: { SidebarVue, NavgatorDk, Rodape, flatPickr },

  data() {
    return {
      isLoadingCompare: false,
      filters: {
        rede: "",
        loja: "",
        periodo: "7",
        gerente: "",
        pcd: "all",
        statusVenda: "all"
      },

      filterOptions: {
        redes: [],
        lojas: [],
        lojasFiltradas: [],
        gerentes: [],
        gerentesFiltrados: []
      },
      // KPIs mockados
      kpis: {
        totalAtendimentos: 0,
        vendasFinalizadas: 0,
        vendasPerdidas: 0,
        clientesPcd: 0,
        conversao: 0,
        mediaValorVeiculo: 0,
        qtdMediaVeiculos: 0,
        vendaTotal: 0,
        totalVendasFinalizadas: 0,
        tempoMedioAt: 0,
        totalRegistros: 0,
        mediaMenus: 0
      },
      contatos: {
        total: 0,
        tel1: 0,
        tel2: 0,
        email: 0
      },
      // tabelas mockadas
      tables: {
        topVendedores: [],
        motivosPerda: []
      },
      semanaCharts: {},
      charts: {
        atendSemana: null,
        vendasSemana: null,
        funil: null,
        motivos: null,
        lojaCombo: null,
        origemLeads: null,
        gerenteCombo: null,
        statusFechamento: null
      },
      rankingVeiculos: [],
      rankingModelos: [],
      lojasBI: [],
      origemLeads: [],
      gerentesBI: [],
      statusFechamento: [],
      topAtendLongos: [],
      topAtendRapidos: [],

      compare: {
        mode: "STORES",
        /* BLOCO 9 */
        stores: ["", ""],
        storeOptions: [],
        maxStores: 5,
        storeData: {},

        /* BLOCO 10 */

        store: null,

        periodMode: "date",

        dayDates: {
          d1: null,
          d2: null
        },

        ranges: {
          r1: [],
          r2: []
        },

        periodData: {
          p1: {},
          p2: {}
        },
        metrics: [
          { key: "atendimentos", label: "Atendimentos" },
          { key: "vendasFinalizadas", label: "Vendas Finalizadas" },
          { key: "taxaConversao", label: "Taxa de Conversão" },
          { key: "vendaTotal", label: "Venda Total" },
          { key: "mediaValorVeiculo", label: "Média Valor Veículo" }
        ]
      },
      dateConfig: {
        dateFormat: "Y-m-d",
        maxDate: "today"
      },

      rangeConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        maxDate: "today"
      },
      geralAvaliacao: {
        media: 4.6,
        atualizadoEm: "29/01/2026"
      }
    };
  },
watch: {
  "filters.rede": function (val) {
    const lojas = this.filterOptions.lojas || [];
    const gerentes = this.filterOptions.gerentes || [];

    if (val === "ALL" || val === "" || val == null) {
      this.filterOptions.lojasFiltradas = [...lojas];
      this.filterOptions.gerentesFiltrados = [...gerentes];
    } else {
      const tipo = Number(val);

      this.filterOptions.lojasFiltradas = lojas.filter(
        (l) => Number(l.tipo_empresa) === tipo
      );

      this.filterOptions.gerentesFiltrados = gerentes.filter(
        (g) => Array.isArray(g.tipos) && g.tipos.includes(tipo)
      );
    }

    // limpa loja se não existir mais
    if (this.filters.loja && !this.filterOptions.lojasFiltradas.some(
      (l) => String(l.id) === String(this.filters.loja)
    )) {
      this.filters.loja = "";
    }

    // 🔥 Aplica o filtro de gerentes baseado na loja atual
    this.filtrarGerentesPorLoja();
  },

  // 🔥 WATCH PARA LOJA - CORRIGIDO
  "filters.loja": {
    handler: function (val) {
      console.log("Loja mudou para:", val);
      // Aplica o filtro de gerentes baseado na loja selecionada
      this.filtrarGerentesPorLoja();
    },
    immediate: true  // Executa imediatamente quando o componente monta
  },

  "filters.periodo"(val) {
    if (val !== "custom") {
      this.filters.startDate = "";
      this.filters.endDate = "";
    }
  },

  "compare.stores": {
    deep: true,
    handler(v) {
      console.log("stores mudou", v);
      this.loadCompare();
    }
  },

  "compare.store"(v) {
    console.log("store period mudou", v);
    this.loadCompare();
  },

  "compare.dayDates": {
    deep: true,
    handler() {
      console.log("datas mudaram", this.compare.dayDates);
      this.loadCompare();
    }
  },

  "compare.ranges": {
    deep: true,
    handler() {
      console.log("ranges mudaram", this.compare.ranges);
      this.loadCompare();
    }
  }
},
  computed: {
    maxAtendVeiculos() {
      return Math.max(
        ...this.rankingVeiculos.map((x) => Number(x.atend || 0)),
        1
      );
    },
    maxFatModelos() {
      return Math.max(
        ...this.rankingModelos.map((x) => Number(x.faturamento || 0)),
        1
      );
    }
  },

 async mounted() {
  // Primeiro carrega opções sem período (para ter lojas)
  await this.loadFilterOptions();

  // Depois aplica os filtros (que vai recarregar com período)
  await this.applyFilters();

  this.loadCompare(); // se quiser
},

  beforeUnmount() {
    if (this.charts?.atendSemana) this.charts.atendSemana.destroy();
    if (this.charts?.vendasSemana) this.charts.vendasSemana.destroy();
    if (this.charts?.lojaCombo) this.charts.lojaCombo.destroy();
    if (this.charts?.origemLeads) this.charts.origemLeads.destroy();
    if (this.charts?.gerenteCombo) this.charts.gerenteCombo.destroy();
    if (this.charts?.statusFechamento) this.charts.statusFechamento.destroy();
  },

  methods: {


    validateDateCompare() {
      const { d1, d2 } = this.compare.dayDates;

      if (!d1 || !d2) return false;

      if (d1 === d2) {
        alert("Datas não podem ser iguais");
        return false;
      }

      return true;
    },
    validateRanges() {
      const r1 = this.compare.ranges.r1;
      const r2 = this.compare.ranges.r2;

      if (r1.length !== 2 || r2.length !== 2) return false;

      const d1 = new Date(r1[1]) - new Date(r1[0]);
      const d2 = new Date(r2[1]) - new Date(r2[0]);

      if (d1 !== d2) {
        alert("Ranges precisam ter o mesmo tamanho");

        return false;
      }

      return true;
    },
    addCompareStore() {
      if (this.compare.stores.length >= this.compare.maxStores) return;

      this.compare.stores.push("");
    },
    removeCompareStore() {
      if (this.compare.stores.length <= 2) return;

      this.compare.stores.pop();
    },
    getStoreMetric(store, key) {
      const row = this.compare.storeData?.[store];

      return row?.[key] ?? 0;
    },
    getVarBetweenStores(key) {
      const stores = this.compare.stores.filter((s) => s);

      if (stores.length < 2) return 0;

      const base = this.getStoreMetric(stores[0], key);
      const last = this.getStoreMetric(stores[stores.length - 1], key);

      if (!base) return 0;

      return ((last - base) / base) * 100;
    },

    formatPeriod(p) {
      if (!p) return "-";

      if (typeof p === "string" && p.includes("-")) {
        const [y, m, d] = p.split("-");
        if (d) return `${d}/${m}/${y}`;
      }

      return p;
    },
    periodInputType(type) {
      if (type === "week") return "week";
      if (type === "month") return "month";
      if (type === "year") return "number";

      return "date";
    },
    daysBetween(a, b) {
      const d1 = new Date(a);
      const d2 = new Date(b);

      return Math.round((d2 - d1) / 86400000);
    },

    validatePeriods() {
      const s1 = this.compare.custom.start1;
      const e1 = this.compare.custom.end1;
      const s2 = this.compare.custom.start2;
      const e2 = this.compare.custom.end2;

      if (!s1 || !e1 || !s2 || !e2) return false;

      const d1 = (new Date(e1) - new Date(s1)) / 86400000;
      const d2 = (new Date(e2) - new Date(s2)) / 86400000;

      if (d1 !== d2) {
        alert("Os períodos precisam ter o mesmo tamanho");
        return false;
      }

      return true;
    },
  // 🔥 NOVO MÉTODO: Filtrar gerentes pela loja selecionada
filtrarGerentesPorLoja() {
  const todosGerentes = this.filterOptions.gerentes || [];
  const lojaSelecionada = this.filters.loja;
  const redeSelecionada = this.filters.rede;

  console.log("🟢 Filtrando gerentes - Loja:", lojaSelecionada, "Tipo:", typeof lojaSelecionada);
  console.log("Rede:", redeSelecionada);

  // 🔥 DEBUG com segurança - verificar se existe antes de acessar
  console.log("📋 DETALHES DOS GERENTES:");
  todosGerentes.forEach(g => {
    console.log(`  ${g.nome}:`);
    console.log(`    - lojas:`, g.lojas || 'não definido');
    console.log(`    - lojas é array?`, Array.isArray(g.lojas));
    console.log(`    - tipos:`, g.tipos || 'não definido');
  });

  let gerentesFiltrados = [...todosGerentes];

  // Primeiro filtra por rede se tiver
  if (redeSelecionada && redeSelecionada !== "" && redeSelecionada !== "ALL") {
    const tipo = Number(redeSelecionada);
    console.log("Filtrando por rede tipo:", tipo);
    gerentesFiltrados = gerentesFiltrados.filter(g => {
      const temTipo = g.tipos && Array.isArray(g.tipos) && g.tipos.includes(tipo);
      console.log(`    ${g.nome}: tem tipo ${tipo}? ${temTipo}`);
      return temTipo;
    });
  }

  // Depois filtra por loja se tiver uma selecionada
  if (lojaSelecionada && lojaSelecionada !== "") {
    const lojaId = Number(lojaSelecionada);
    console.log("🔍 Filtrando por loja ID:", lojaId);

    gerentesFiltrados = gerentesFiltrados.filter(gerente => {
      // 🔥 Verificação segura
      if (!gerente.lojas || !Array.isArray(gerente.lojas)) {
        console.log(`    ❌ ${gerente.nome}: lojas não é array válido`);
        return false;
      }

      // Converter para número se necessário
      const lojasNumericas = gerente.lojas.map(id => Number(id));
      const temAcesso = lojasNumericas.includes(lojaId);

      if (temAcesso) {
        console.log(`    ✅ ${gerente.nome}: acessa loja ${lojaId}`);
      } else {
        console.log(`    ❌ ${gerente.nome}: NÃO acessa loja ${lojaId}. Lojas:`, lojasNumericas);
      }

      return temAcesso;
    });
  }

  console.log("📊 Gerentes filtrados:", gerentesFiltrados.map(g => g.nome));

  this.filterOptions.gerentesFiltrados = gerentesFiltrados;

  if (this.filters.gerente && !gerentesFiltrados.some(g => String(g.id) === String(this.filters.gerente))) {
    console.log("Gerente selecionado não está mais disponível, limpando...");
    this.filters.gerente = "";
  }
},
async loadFilterOptions() {
  try {
    // 🔥 Use os parâmetros atuais dos filtros
    const params = this.buildFilterParams();

    const { data } = await axios.get(
      `${process.env.VUE_APP_API_URL}bi/options`,
      { params }
    );

    if (!data?.ok) return;

    console.log("Dados dos filtros recebidos:", data);

    this.filterOptions.redes = data.redes || [];
    this.filterOptions.lojas = data.lojas || [];

    // 🔥 IMPORTANTE: Preservar o campo lojas
    this.filterOptions.gerentes = (data.gerentes || []).map(gerente => ({
      id: gerente.id,
      nome: gerente.nome,
      lojas: gerente.lojas || [],  // ← Garantir que é array
      tipos: gerente.tipos || []
    }));

    this.filterOptions.lojasFiltradas = [...this.filterOptions.lojas];
    this.filterOptions.gerentesFiltrados = [...this.filterOptions.gerentes];
    this.compare.storeOptions = this.filterOptions.lojas;

    // Aplica filtro de loja se houver
    this.$nextTick(() => {
      if (this.filters.loja) {
        this.filtrarGerentesPorLoja();
      }
    });

  } catch (error) {
    console.error("Erro ao carregar opções:", error);
  }
},
    async dashboard(params = {}) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}bi/dashboard`,
        { params }
      );

      const data = response.data;
      // alimenta o que o template já lê
      this.kpis = data.kpis || {};
      this.contatos = data.contatos || {};
      this.semanaCharts = data.semanaCharts || {};
      this.statusFechamento = data.statusFechamento || [];
      this.origemLeads = data.origemLeads || [];
      this.lojasBI = data.lojasBI || [];
      this.gerentesBI = data.gerentesBI || [];
      this.rankingVeiculos = data.rankingVeiculos || [];
      this.rankingModelos = data.rankingModelos || [];
      this.topAtendLongos = data.topAtendLongos || [];
      this.topAtendRapidos = data.topAtendRapidos || [];
      this.tables = data.tables || { topVendedores: [], motivosPerda: [] };

      console.log("Dash BI carregado", data);
      this.$nextTick(() => {
        console.log("refs disponíveis:", Object.keys(this.$refs));
        console.log("ref atend:", this.$refs.chartAtendDiaSemana);
        console.log("ref vendas:", this.$refs.chartVendasDiaSemana);
        this.renderBloco3();
        this.renderBloco5();
        this.renderBloco6();
        this.renderBloco7();
      });
    },

    async loadCompare() {
      console.log("🔥 loadCompare executou");

      const baseUrl = `${process.env.VUE_APP_API_URL}bi/compare`;
      const baseFilters = this.buildFilterParams();
      const mode = this.compare.mode || "STORES";

      let params = {};

      // =========================
      // BLOCO 9 (LOJAS)
      // =========================

      if (mode === "STORES") {
        const stores = this.compare.stores
          .map((s) => (typeof s === "object" ? s?.id : s))
          .filter(Boolean);

        if (stores.length < 2) return;

        params = {
          mode: "STORES",
          stores: stores.join(","),
          ...baseFilters
        };
      }

      // =========================
      // BLOCO 10 (PERÍODOS)
      // =========================

      if (mode === "PERIODS") {
        if (!this.compare.store) return;

        // DATA x DATA
        if (this.compare.periodMode === "date") {
          const { d1, d2 } = this.compare.dayDates;

          if (!d1 || !d2) return;

          params = {
            mode: "PERIODS",
            store: this.compare.store,
            p1: d1,
            p2: d2,
            ...baseFilters
          };
        }

        // RANGE x RANGE
        if (this.compare.periodMode === "custom") {
          const r1 = (this.compare.ranges.r1 || "").split(" to ");
          const r2 = (this.compare.ranges.r2 || "").split(" to ");

          if (r1.length !== 2 || r2.length !== 2) return;

          params = {
            mode: "PERIODS",
            store: this.compare.store,
            p1Start: r1[0],
            p1End: r1[1],
            p2Start: r2[0],
            p2End: r2[1],
            ...baseFilters
          };

          console.log("PARAMS PERIODS:", params);
        }
      }

      console.log("PARAMS ENVIADOS:", params);

      try {
        const response = await axios.get(baseUrl, { params });

        if (mode === "STORES") {
          this.compare.storeData = response.data.compare.storeData;
          console.log("STORE DATA FRONT:", this.compare.storeData);
        }

        if (mode === "PERIODS") {
          this.compare.periodData = response.data.compare.periodData;
          console.log("PERIOD DATA FRONT:", this.compare.periodData);
        }
      } catch (err) {
        console.log("ERRO API", err);
      }
    },
    buildFilterParams() {
      const f = this.filters;

      const params = {
        rede: f.rede ?? undefined,
        loja: f.loja ?? undefined,
        gerente: f.gerente ?? undefined,
        pcd: f.pcd ?? "all",
        statusVenda: f.statusVenda ?? "all"
      };

      if (f.periodo !== "custom") {
        params.days = Number(f.periodo) || 30;
      } else {
        if (f.startDate && f.endDate) {
          params.startDate = f.startDate;
          params.endDate = f.endDate;
        }
      }

      return params;
    },

 async applyFilters() {
  const params = this.buildFilterParams();
  await this.dashboard(params);
},

    resetFilters() {
      this.filters = {
        rede: "",
        loja: "",
        periodo: "30",
        gerente: "",
        pcd: "all",
        statusVenda: "all"
      };

      this.applyFilters().catch(console.error);
    },

    renderCharts() {
      // destrói se já existirem
      Object.keys(this.charts).forEach((k) => {
        if (this.charts[k]) this.charts[k].destroy();
        this.charts[k] = null;
      });

      const labelsSemana = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

      // ---------- Atendimentos (Bar)
      this.charts.atendSemana = new Chart(this.$refs.chartAtendSemana, {
        type: "bar",
        data: {
          labels: labelsSemana,
          datasets: [
            {
              label: "Atendimentos",
              data: [62, 71, 68, 77, 92, 54, 52],
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: true } },
          scales: {
            y: { beginAtZero: true }
          }
        }
      });

      // ---------- Vendas (Line)
      this.charts.vendasSemana = new Chart(this.$refs.chartVendasSemana, {
        type: "line",
        data: {
          labels: labelsSemana,
          datasets: [
            {
              label: "Vendas",
              data: [14, 18, 19, 21, 28, 20, 19],
              fill: true,
              tension: 0.35,
              pointRadius: 3,
              borderWidth: 2
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: true } },
          scales: {
            y: { beginAtZero: true }
          }
        }
      });

      // ---------- Funil (Bar horizontal “fake”)
      // OBS: Chart.js horizontal bar => bar com indexAxis: 'y'
      this.charts.funil = new Chart(this.$refs.chartFunil, {
        type: "bar",
        data: {
          labels: ["Atendimentos", "Propostas", "Negociações", "Vendas"],
          datasets: [
            {
              label: "Volume",
              data: [476, 290, 210, 139],
              borderWidth: 1
            }
          ]
        },
        options: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            x: { beginAtZero: true }
          }
        }
      });

      // ---------- Motivos (Doughnut)
      this.charts.motivos = new Chart(this.$refs.chartMotivos, {
        type: "doughnut",
        data: {
          labels: this.tables.motivosPerda.map((x) => x.motivo),
          datasets: [
            {
              label: "Qtd",
              data: this.tables.motivosPerda.map((x) => x.qtd),
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { position: "bottom" } }
        }
      });
    },
    pct(value, total) {
      const v = Number(value || 0);
      const t = Number(total || 0);
      if (!t) return "0.0";
      return ((v / t) * 100).toFixed(1);
    },
    renderBloco3() {
      // garante que this.charts exista
      if (!this.charts) this.charts = {};

      // pega semanaCharts com fallback
      var sc = this.semanaCharts || {};

      // CORREÇÃO: Pega os dados crus da API
      var rawAtendimentos =
        Array.isArray(sc.atendimentos) && sc.atendimentos.length
          ? sc.atendimentos
          : [0, 0, 0, 0, 0, 0, 0];

      var rawVendas =
        Array.isArray(sc.vendas) && sc.vendas.length
          ? sc.vendas
          : [0, 0, 0, 0, 0, 0, 0];

      // CORREÇÃO: Reordenar os dados para garantir que Segunda-feira seja primeiro
      // Problema comum: API retorna começando no Domingo (índice 0)
      // Solução: Rotacionar o array para que Segunda (índice 1 do JS) seja primeiro
      var atendimentos = [...rawAtendimentos];
      var vendas = [...rawVendas];

      // Detecta se os dados estão desalinhados (Domingo na primeira posição)
      // Normalmente Domingo tem baixo volume, podemos usar isso como heurística
      // Mas vamos fazer uma rotação segura baseada no fato que a API pode retornar na ordem DOM,SEG,TER,QUA,QUI,SEX,SAB
      if (atendimentos.length === 7) {
        // Move o primeiro elemento (Domingo) para o final
        // Isso transforma [DOM, SEG, TER, QUA, QUI, SEX, SAB]
        // em [SEG, TER, QUA, QUI, SEX, SAB, DOM]
        var firstAtend = atendimentos.shift();
        atendimentos.push(firstAtend);

        var firstVenda = vendas.shift();
        vendas.push(firstVenda);
      }

      // Labels agora começam na Segunda-feira
      var labels = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

      // refs
      if (!this.$refs.chartAtendDiaSemana || !this.$refs.chartVendasDiaSemana)
        return;

      // destrói se já existir
      if (this.charts.atendSemana) this.charts.atendSemana.destroy();
      if (this.charts.vendasSemana) this.charts.vendasSemana.destroy();

      // max dinâmico
      var maxAtend = 10;
      for (var i = 0; i < atendimentos.length; i++) {
        var v = Number(atendimentos[i]) || 0;
        if (v > maxAtend) maxAtend = v;
      }

      var maxVendas = 10;
      for (var j = 0; j < vendas.length; j++) {
        var w = Number(vendas[j]) || 0;
        if (w > maxVendas) maxVendas = w;
      }

      // ATENDIMENTOS
      this.charts.atendSemana = new Chart(this.$refs.chartAtendDiaSemana, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Atendimentos",
              data: atendimentos.map(function (n) {
                return Number(n) || 0;
              }),
              borderWidth: 0,
              borderRadius: 6,
              backgroundColor: [
                "#2563eb",
                "#0891b2",
                "#06b6d4",
                "#10b981",
                "#f59e0b",
                "#a855f7",
                "#e5e7eb"
              ]
            }
          ]
        },
        options: this.biBarOptions({ maxY: Math.ceil(maxAtend * 1.15) })
      });

      // VENDAS
      this.charts.vendasSemana = new Chart(this.$refs.chartVendasDiaSemana, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Vendas",
              data: vendas.map(function (n) {
                return Number(n) || 0;
              }),
              borderWidth: 0,
              borderRadius: 6,
              backgroundColor: "#16a34a"
            }
          ]
        },
        options: this.biBarOptions({ maxY: Math.ceil(maxVendas * 1.15) })
      });

      // DEBUG: opcional - descomente para verificar o reordenamento
      console.log("RAW atendimentos:", rawAtendimentos);
      console.log("REORDERED atendimentos:", atendimentos);
      console.log("Labels:", labels);
    },

    biBarOptions({ maxY }) {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true }
        },
        layout: { padding: { top: 10, left: 6, right: 10, bottom: 6 } },
        scales: {
          x: {
            grid: { display: false },
            ticks: { font: { size: 12 } }
          },
          y: {
            beginAtZero: true,
            suggestedMax: maxY,
            ticks: { font: { size: 12 } },
            grid: { borderDash: [4, 4] }
          }
        }
      };
    },
    barWidth(value, max) {
      const v = Number(value || 0);
      const m = Number(max || 1);
      const pct = Math.max(0, Math.min(100, (v / m) * 100));
      return pct.toFixed(1) + "%";
    },
    fmtInt(n) {
      return Number(n || 0).toLocaleString("pt-BR");
    },
    fmtPct(n) {
      return `${Number(n || 0).toFixed(1)}%`;
    },

    fmtBRL(n) {
      const value = Number(n || 0);
      const formatCompact = (val, suffix) => {
        const num = val.toFixed(2);
        // remove .00 quando não precisa
        const clean = num.endsWith(".00") ? num.slice(0, -3) : num;
        return `R$ ${clean}${suffix}`;
      };

      if (value >= 1000000000) return formatCompact(value / 1000000000, "B");
      if (value >= 1000000) return formatCompact(value / 1000000, "M");
      if (value >= 1000) return formatCompact(value / 1000, "K");

      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    fmtDurationFromSec(seconds) {
      const total = Number(seconds || 0);

      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);

      if (hours > 0) {
        return minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`;
      }

      return `${minutes} min`;
    },

    renderBloco5() {
      // destroy
      if (this.charts.lojaCombo) this.charts.lojaCombo.destroy();
      if (this.charts.origemLeads) this.charts.origemLeads.destroy();

      // ====== COMBO: atend/vendas + linha de conversão (%)
      const labels = this.lojasBI.map((x) => x.loja);
      const atend = this.lojasBI.map((x) => Number(x.atend || 0));
      const vendas = this.lojasBI.map((x) => Number(x.vendas || 0));
      const convPct = this.lojasBI.map((x) => {
        const a = Number(x.atend || 0);
        const v = Number(x.vendas || 0);
        return a ? +((v / a) * 100).toFixed(1) : 0;
      });
      const lineShadowPlugin = {
        id: "lineShadow",
        beforeDatasetsDraw(chart) {
          const { ctx } = chart;

          chart.data.datasets.forEach((dataset, i) => {
            if (dataset.type === "line") {
              const meta = chart.getDatasetMeta(i);
              ctx.save();
              ctx.shadowColor = "rgba(0,0,0,0.25)";
              ctx.shadowBlur = 10;
              ctx.shadowOffsetY = 4;
              meta.dataset.draw(ctx);
              ctx.restore();
            }
          });
        }
      };

      this.charts.lojaCombo = new Chart(this.$refs.chartLojaCombo, {
        type: "bar",
        plugins: [lineShadowPlugin],
        data: {
          labels,
          datasets: [
            {
              type: "bar",
              label: "Atendimentos",
              data: atend,
              borderWidth: 0,
              borderRadius: 6,
              backgroundColor: "#2563eb",
              yAxisID: "y",
              order: 2
            },
            {
              type: "bar",
              label: "Vendas",
              data: vendas,
              borderWidth: 0,
              borderRadius: 6,
              backgroundColor: "#16a34a",
              yAxisID: "y",
              order: 2
            },
            {
              type: "line",
              label: "Conversão (%)",
              data: convPct,
              tension: 0.4,
              borderWidth: 3,
              pointRadius: 5,
              pointHoverRadius: 6,
              pointBackgroundColor: "#111827",
              pointBorderColor: "#ffffff",
              pointBorderWidth: 2,
              borderColor: "#111827",
              yAxisID: "y1",
              order: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          layout: { padding: { top: 8, left: 6, right: 10, bottom: 6 } },
          scales: {
            x: {
              ticks: {
                maxRotation: 0,
                autoSkip: false,
                callback: (val) => {
                  const s = labels[val] || "";
                  // quebra o label pra não estourar
                  return s.length > 18 ? s.slice(0, 18) + "…" : s;
                }
              },
              grid: { display: false }
            },
            y: {
              beginAtZero: true,
              grid: { borderDash: [4, 4] },
              ticks: { callback: (v) => this.fmtInt(v) }
            },
            y1: {
              beginAtZero: true,
              position: "right",
              grid: { drawOnChartArea: false },
              ticks: { callback: (v) => `${v}%` },
              suggestedMax: Math.max(...convPct, 10) + 5
            }
          }
        }
      });

      // ====== DONUT: origem leads
      const origemLabels = this.origemLeads.map((x) => x.nome);
      const origemValues = this.origemLeads.map((x) => Number(x.qtd || 0));

      this.charts.origemLeads = new Chart(this.$refs.chartOrigemLeads, {
        type: "doughnut",
        data: {
          labels: origemLabels,
          datasets: [
            {
              label: "Leads",
              data: origemValues,
              borderWidth: 1,
              backgroundColor: [
                "#2563eb", // azul
                "#10b981", // verde
                "#f59e0b", // amarelo
                "#8b5cf6", // roxo
                "#ef4444", // vermelho
                "#06b6d4", // ciano
                "#14b8a6", // teal
                "#eab308" // gold
              ]
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false }, // usamos legenda em lista
            tooltip: { enabled: true }
          },
          cutout: "62%"
        }
      });
    },
    renderBloco6() {
      if (this.charts.gerenteCombo) this.charts.gerenteCombo.destroy();

      // ordena por conversão (vendas/atend)
      const sorted = [...this.gerentesBI].sort((a, b) => {
        const ca = a.atend ? a.vendas / a.atend : 0;
        const cb = b.atend ? b.vendas / b.atend : 0;
        return cb - ca;
      });

      // CORREÇÃO: usar os dados ordenados para labels também
      const labels = sorted.map((x) => x.gerente);
      const atend = sorted.map((x) => Number(x.atend || 0));
      const vendas = sorted.map((x) => Number(x.vendas || 0));
      const convPct = sorted.map((x) => {
        const a = Number(x.atend || 0);
        const v = Number(x.vendas || 0);
        return a ? +((v / a) * 100).toFixed(1) : 0;
      });

      // CORREÇÃO: adicionar o mesmo plugin de sombra
      const lineShadowPlugin = {
        id: "lineShadow",
        beforeDatasetsDraw(chart) {
          const { ctx } = chart;
          chart.data.datasets.forEach((dataset, i) => {
            if (dataset.type === "line") {
              const meta = chart.getDatasetMeta(i);
              ctx.save();
              ctx.shadowColor = "rgba(0,0,0,0.25)";
              ctx.shadowBlur = 10;
              ctx.shadowOffsetY = 4;
              meta.dataset.draw(ctx);
              ctx.restore();
            }
          });
        }
      };

      this.charts.gerenteCombo = new Chart(this.$refs.chartGerenteCombo, {
        type: "bar",
        plugins: [lineShadowPlugin], // CORREÇÃO: adicionar plugin
        data: {
          labels,
          datasets: [
            {
              type: "bar",
              label: "Atendimentos",
              data: atend,
              borderWidth: 0,
              borderRadius: 6,
              backgroundColor: "#2563eb",
              yAxisID: "y",
              order: 2 // CORREÇÃO: adicionar order para consistência
            },
            {
              type: "bar",
              label: "Vendas",
              data: vendas,
              borderWidth: 0,
              borderRadius: 6,
              backgroundColor: "#16a34a",
              yAxisID: "y",
              order: 2 // CORREÇÃO: adicionar order
            },
            {
              type: "line",
              label: "Conversão (%)",
              data: convPct,
              tension: 0.35,
              borderWidth: 3, // CORREÇÃO: aumentar para 3 (igual ao de lojas)
              pointRadius: 5, // CORREÇÃO: aumentar para 5
              pointHoverRadius: 6, // CORREÇÃO: adicionar hover radius
              pointBackgroundColor: "#111827", // CORREÇÃO: adicionar cor do ponto
              pointBorderColor: "#ffffff", // CORREÇÃO: adicionar borda do ponto
              pointBorderWidth: 2, // CORREÇÃO: adicionar largura da borda
              backgroundColor: "#111827",
              borderColor: "#111827",
              yAxisID: "y1",
              order: 1 // CORREÇÃO: adicionar order
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          layout: { padding: { top: 8, left: 6, right: 10, bottom: 6 } },
          scales: {
            x: {
              grid: { display: false },
              ticks: {
                maxRotation: 55,
                minRotation: 55,
                callback: (val) => {
                  const s = labels[val] || "";
                  return s.length > 22 ? s.slice(0, 22) + "…" : s;
                }
              }
            },
            y: {
              beginAtZero: true,
              grid: { borderDash: [4, 4] },
              ticks: { callback: (v) => this.fmtInt(v) }
            },
            y1: {
              beginAtZero: true,
              position: "right",
              grid: { drawOnChartArea: false },
              ticks: { callback: (v) => `${v}%` },
              suggestedMax: Math.max(...convPct, 10) + 5
            }
          }
        }
      });
    },
    renderBloco7() {
      if (this.charts.statusFechamento) this.charts.statusFechamento.destroy();

      const labels = this.statusFechamento.map((x) => x.nome);
      const values = this.statusFechamento.map((x) => Number(x.qtd || 0));

      this.charts.statusFechamento = new Chart(
        this.$refs.chartStatusFechamento,
        {
          type: "pie",
          data: {
            labels,
            datasets: [
              {
                label: "Status",
                data: values,
                borderWidth: 1,
                // cores alinhadas ao print (azul grande + verde)
                backgroundColor: ["#10b981", "#ef4444", "#f59e0b"]
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false }, // legenda custom abaixo
              tooltip: { enabled: true }
            }
          }
        }
      );
    },
    shortLabel(name) {
      // pra caber na tabela
      if (!name) return "";
      return name.length > 28 ? name.slice(0, 28) + "…" : name;
    },

    getVarBetweenPeriods(key) {
      const a = this.compare.periodData?.p1?.[key] ?? 0;
      const b = this.compare.periodData?.p2?.[key] ?? 0;
      return this.calcVarPct(a, b);
    },
    calcVarPct(base, current) {
      const b = Number(base || 0);
      const c = Number(current || 0);
      if (b === 0) return c === 0 ? 0 : 100; // padrão do seu print (quando base 0)
      return ((c - b) / b) * 100;
    },
    varClass(pct) {
      if (pct > 0.0001) return "bi-var-up";
      if (pct < -0.0001) return "bi-var-down";
      return "bi-var-flat";
    },
    varIcon(pct) {
      if (pct > 0.0001) return "bi-arrow-up";
      if (pct < -0.0001) return "bi-arrow-down";
      return "bi-dash";
    },
    fmtPctAbs(pct) {
      const v = Math.abs(Number(pct || 0));
      return v.toFixed(1) + "%";
    },
    formatMetric(key, value) {
      const v = Number(value || 0);

      if (key === "taxaConversao") return v.toFixed(1) + "%";
      if (key === "vendaTotal") return this.fmtBRL(v);
      if (key === "mediaValorVeiculo") return this.fmtBRL(v);

      return this.fmtInt(v);
    },
    fmtDate(iso) {
      if (!iso) return "";

      const [m, d] = iso.split("-");
      if (!d) return iso;

      return `${d}/${m}`;
    },
    starClass(score, n) {
      // estrela cheia se score >= n
      // meia estrela opcional: aqui simplifiquei (igual print, só cheia/vazia)
      return score >= n
        ? "bi bi-star-fill bi-star-on"
        : "bi bi-star bi-star-off";
    }
  }
};
</script>

<style scoped>
/* ================================
   FORMULÁRIOS / INPUTS
================================ */
.btn-loja {
  margin-top: 23px;
}
/* ================================
   TABELAS
================================ */
.bi-table-head {
  background: #f4f6f9;
  border-bottom: 2px solid #e2e6ea;
}

.bi-table-head th {
  font-weight: 600;
  font-size: 13px;
  color: #495057;
}

.table tbody tr:hover {
  background: #f8fafc;
}
/* ================================
   CARDS / GRÁFICOS
================================ */
.bi-chart-fixed {
  height: 345px;
  position: relative;
}
.bi-equal-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.bi-chart-area {
  position: relative;
  width: 100%;
  height: 360px; /* fixa altura do gráfico */
  flex: 0 0 auto; /* impede crescer */
}

.bi-chart-area canvas {
  display: block;
}

/* ================================
   SCROLL CUSTOM
================================ */
.flex-grow-1::-webkit-scrollbar {
  width: 4px;
}

.flex-grow-1::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.flex-grow-1::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.flex-grow-1::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.flex-grow-1 {
  scrollbar-width: thin;
  scrollbar-color: #ccc #f1f1f1;
}

.border-bottom {
  border-bottom: 1px solid #edf2f7 !important;
}

.flex-grow-1 > div:hover {
  background-color: #f8fafc;
}
/* ================================
   RATING
================================ */
.bi-rating-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.03);
}

.bi-rating-label {
  font-weight: 900;
  color: #111827;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

.bi-stars {
  display: inline-flex;
  gap: 2px;
  align-items: center;
}

.bi-star-on {
  color: #fbbf24; /* amarelo */
  font-size: 1.05rem;
}
.bi-star-off {
  color: rgba(17, 24, 39, 0.25);
  font-size: 1.05rem;
}

.bi-rating-right {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.bi-rating-score {
  font-weight: 900;
  color: #111827;
  min-width: 44px;
  text-align: right;
}

.bi-rating-list {
  max-height: 360px;
  overflow: auto;
  padding-right: 6px;
}

.bi-rating-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.bi-rating-row:last-child {
  border-bottom: none;
}

.bi-rating-name {
  font-weight: 900;
  color: #111827;
}

.bi-rating-addr {
  color: #6b7280;
  font-weight: 600;
  margin-top: 2px;
  font-size: 0.95rem;
}

.bi-rating-footer {
  color: #6b7280;
  font-weight: 600;
  font-size: 0.9rem;
  text-align: center;
  padding: 12px 0 2px;
}

/* ================================
   COMPARATIVOS
================================ */
.bi-compare-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bi-compare-select {
  width: 160px;
  max-width: 160px;
}

.bi-var {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 900;
  white-space: nowrap;
}

.bi-var-up {
  color: #16a34a;
}
.bi-var-down {
  color: #dc2626;
}
.bi-var-flat {
  color: #6b7280;
}
/* ================================
   TEMPO / RANK
================================ */
.bi-time-hint {
  font-weight: 800;
  padding: 10px 12px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 0, 0, 0.03);
}

.bi-time-hint-danger {
  color: #dc2626;
}
.bi-time-hint-success {
  color: #16a34a;
}

.bi-time-list {
  display: grid;
  gap: 12px;
}

.bi-time-row {
  display: grid;
  grid-template-columns: 46px 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  background: #fff;
}

.bi-time-rank {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-weight: 900;
}

.bi-rank-danger {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}

.bi-rank-success {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.bi-time-title {
  display: flex;
  gap: 10px;
  align-items: baseline;
  flex-wrap: wrap;
}

.bi-time-proto {
  font-weight: 900;
  color: #111827;
}

.bi-time-name {
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  color: #111827;
}

.bi-time-sub {
  margin-top: 4px;
  color: #6b7280;
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.15px;
}

.bi-time-right {
  color: #374151;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.bi-time-duration {
  font-weight: 900;
}

.bi-chart-wrap-lg {
  height: 360px;
}
.bi-chart-wrap-md {
  height: 300px;
}
.bi-chart-wrap-xl {
  height: 420px;
}
.bi-chart-wrap-pie {
  height: 360px;
}

/* ================================
   STATUS / ORIGEM
================================ */
.bi-status-legend {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding-top: 8px;
}

.bi-status-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.bi-status-row:last-child {
  border-bottom: none;
}

.bi-status-name {
  font-weight: 900;
  color: #111827;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  font-size: 0.95rem;
}

.bi-status-val {
  font-weight: 700;
  color: #6b7280;
}

.bi-status-pct {
  font-weight: 900;
  color: #2563eb;
}

.bi-legend-hint {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 8px;
  color: #6b7280;
  font-size: 0.95rem;
  font-weight: 600;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  margin-right: 6px;
  vertical-align: middle;
}
.dot-blue {
  background: #2563eb;
}
.dot-green {
  background: #16a34a;
}
.dot-dark {
  background: #111827;
}

.bi-origin-list {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding-top: 8px;
}
.bi-origin-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.bi-origin-row:last-child {
  border-bottom: none;
}

.bi-origin-name {
  font-weight: 800;
  color: #111827;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  font-size: 0.95rem;
}
.bi-origin-val {
  color: #6b7280;
  font-weight: 700;
}
.bi-origin-pct {
  color: #2563eb;
  font-weight: 900;
}
/* ================================
   RANK LIST
================================ */
.bi-rank-list {
  max-height: 420px;
  overflow: auto;
  padding-right: 6px;
  margin-top: 10px;
}

.bi-rank-row {
  display: grid;
  grid-template-columns: 42px 1fr;
  gap: 10px;
  padding: 12px 6px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.bi-rank-row:last-child {
  border-bottom: none;
}

.bi-rank-pos {
  font-weight: 800;
  color: #6b7280;
  font-size: 1.2rem;
  line-height: 1;
  padding-top: 2px;
}

.bi-rank-title {
  font-weight: 800;
  color: #111827;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.bi-rank-meta {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.bi-rank-meta-item {
  font-size: 1rem;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.bi-rank-link {
  color: #2563eb;
  font-weight: 700;
}

.bi-money {
  color: #16a34a;
  font-weight: 800;
}

.bi-up {
  color: #16a34a;
  font-weight: 700;
}
.bi-down {
  color: #6b7280;
  font-weight: 700;
}

.bi-rank-bar {
  height: 8px;
  background: rgba(17, 24, 39, 0.1);
  border-radius: 999px;
  margin-top: 10px;
  overflow: hidden;
}

.bi-rank-bar-fill {
  height: 100%;
  width: 0%;
  background: #2563eb;
  border-radius: 999px;
}

/* um pouco mais baixo no mobile */

/* ================================
   CONTATOS
================================ */
.bi-contact-grid {
  display: grid;
  grid-template-columns: 1fr;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  margin-top: 10px;
}
.bi-contact-item {
  padding: 14px 10px;
}
.bi-contact-head {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.95rem;
}
.bi-contact-head i {
  font-size: 1.1rem;
  color: #2a2b3f;
  opacity: 0.8;
}
.bi-contact-value {
  font-size: 2.4rem;
  font-weight: 900;
  margin-top: 6px;
  color: #111827;
  line-height: 1;
}
.bi-contact-sub {
  margin-top: 6px;
  font-size: 1.05rem;
  color: #6b7280;
}
.bi-chart-wrap {
  position: relative;
  width: 100%;
  height: 320px; /* desktop/tablet */
}

/* ================================
   RESPONSIVO
================================ */

/* 2 colunas no mobile maior */
@media (min-width: 576px) {
  .bi-contact-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .bi-contact-item {
    border-right: 1px solid rgba(0, 0, 0, 0.08);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .bi-contact-item:nth-child(2n) {
    border-right: none;
  }
  .bi-contact-item:nth-last-child(-n + 2) {
    border-bottom: none;
  }
  .bi-time-row {
    grid-template-columns: 46px 1fr;
  }
  .bi-time-right {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
}
@media (max-width: 767px) {
  .bi-chart-wrap {
    height: 260px; /* mobile */
  }
  .bi-rank-list {
    max-height: 360px;
  }
  .bi-chart-wrap-lg {
    height: 300px;
  }
  .bi-chart-wrap-md {
    height: 260px;
  }
  .bi-chart-wrap-xl {
    height: 360px;
  }
  .bi-chart-wrap-pie {
    height: 300px;
  }
  .bi-rating-list {
    max-height: 300px;
  }
}

/* 4 colunas no desktop */
@media (min-width: 992px) {
  .bi-contact-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  .bi-contact-item {
    border-bottom: none;
  }
  .bi-contact-item:nth-child(2n) {
    border-right: 1px solid rgba(0, 0, 0, 0.08);
  }
  .bi-contact-item:last-child {
    border-right: none;
  }
}
</style>
